import ProductsPage from "../../../components/settings/products/ProductsPage"

export default ProductsPage
